/**
 * Marks the section being read in an "On this page" list. The band's bottom inset keeps the mark on the element the
 * reader is actually under: with a whole column in view, every element intersects and the last one would always win.
 * A callback only receives the elements whose state just changed, so the ones inside the band are tracked across
 * calls; the first of them in document order is the one marked. Returns the observer's disconnect.
 */
export function observeReadingBand(elements: HTMLElement[], onActive: (id: string) => void, root?: Element | null) {
    const inBand = new Set<string>();
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) =>
                entry.isIntersecting ? inBand.add(entry.target.id) : inBand.delete(entry.target.id)
            );
            const first = elements.find((element) => inBand.has(element.id));
            if (first) onActive(first.id);
        },
        { root, rootMargin: '0px 0px -60% 0px', threshold: 0 }
    );
    elements.forEach((element) => observer.observe(element));
    return () => observer.disconnect();
}
